import { AxiosInstance } from 'axios';
import * as t from 'io-ts';
import { decodeP } from './helpers/decode';
import { ApiProps } from './types';
import {
  isBadRequestHttpError,
  isNotAuthorizedHttpError,
} from '../utils/httpErrors';
import { BadRequestError } from './errors/BadRequestError';
import { NotAuthorizedError } from './errors/NotAuthorizedError';
import { UnexpectedError } from './errors/UnexpectedError';

const userDecoder = t.type({
  userId: t.number,
});

export const users = (apiClient: AxiosInstance) => ({
  create: async ({ clientId, clientSecret }: ApiProps) => {
    try {
      const { data } = await apiClient.post('/v2/studio-integrations/users', {
        clientId,
        clientSecret,
      });

      return await decodeP(userDecoder, data);
    } catch (e) {
      if (isNotAuthorizedHttpError(e)) {
        throw new NotAuthorizedError();
      }

      if (isBadRequestHttpError(e)) {
        throw new BadRequestError();
      }

      throw new UnexpectedError();
    }
  },
});
